import React, { Fragment} from "react";
import { connect } from "react-redux";
import {useLocation} from "react-router-dom";

import LookFeature from "./lookFeature/lookFeature";
import LookFeatureInfo from "./lookFeature/lookFeatureInfo";
import {LOOK_WALLS} from "../../core/constants";
// import LookWallsSection from "./lookWallsSection";
import LookMainFeatureGroups from "./lookMainFeatureGroups";
import LookMainHeader from "./lookMainHeader";
import LookMainDeleteNotification from "./lookMainDeleteNotification";
import LookMainCategory from "./lookCategory/lookMainCategory";
import LookCategoryHeader from "./lookCategory/lookCategoryHeader";
import LookFilters from "../lookFilters/lookFilters";
import {getFeatureSectionIsHidden} from "../lookFunctions2";
import LookWizard from "./lookWizard/lookWizard";
import {ROUTES} from "../../../../routes";
import LookWizardHeader from "./lookWizard/lookWizardHeader";
import LookMainWizardSections from "./lookMainWizardSections";
import LookMainWizardSelectedSteps from "./lookMainWizardSelectedSteps";
import LookWizardLmContent from "./lookWizard/lookWizardLmContent";
import LookCompatabilitySection from "./lookCompatability/lookCompatabilitySection";

const LookMainSections = (props) => {

  const {sectionStyles, lookActiveFeature, moreInfoOpened, lookActiveCategory, lookRemovedCartItems, filtersOpened,
    lookCompatabilityAlert, lookLockedTutorial, wizardActiveItem} = props;

  const location = useLocation();
  // lookAllWallsOpened

  // const [overflowVisible, setOverflowVisible] = useState(false);
  // let timeoutId = 0;
  //
  // const updateOpening = () => {
  //   // console.log("updateOpening", );
  //   if (lookActiveFeature) {
  //     clearTimeout(timeoutId);
  //     timeoutId = setTimeout(() => {
  //       setOverflowVisible(true)
  //     }, 300)
  //   } else {
  //     setOverflowVisible(false)
  //   }
  //
  // }
  //
  // useEffect(() => {
  //   updateOpening();
  //   return () => {
  //     clearTimeout(timeoutId);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [lookActiveFeature])

  const contentStyles = {
    width: moreInfoOpened ? 320 * 3 : 320
  }

  const featureSectionIsHidden = getFeatureSectionIsHidden(lookActiveFeature);
  const showWizard = location && location.pathname && location.pathname.includes(ROUTES.wizard);

  return (
    <Fragment>
      <header className="lm-header">
        {showWizard
          ? <LookWizardHeader/>
          : lookActiveCategory ? <LookCategoryHeader/> : <LookMainHeader/>}
      </header>
      <section className={"lm-section"
        + ((lookActiveFeature && !LOOK_WALLS.includes(lookActiveFeature.partId)) || lookActiveCategory || showWizard ? " lm-section--slide-left lm-section--hidden" : "")
        + (!lookActiveFeature && !lookActiveCategory && !showWizard ? " lm-section--active" : "")}>
        <div className="lm-content lm-content--groups">
          <LookMainFeatureGroups/>
          {lookRemovedCartItems.length ? <LookMainDeleteNotification/> : null}
        </div>
      </section>
      <section className={"lm-section lm-section--category" + (!lookActiveCategory || showWizard ? " lm-section--slide-right lm-section--hidden" : "")}>
        <LookMainCategory contentHeight={sectionStyles.height}/>
      </section>
      <section className={"lm-section lm-section--feature lm-section--slide-right"
        // + (!lookActiveFeature && !filtersOpened ? " lm-section--slide-right-more lm-section--hidden" : "")
        + (filtersOpened && !showWizard ? " lm-section--active" : " lm-section--hidden")}>
        <LookFilters wrapperStyles={contentStyles}/>
      </section>
      <section className={"lm-section lm-section--feature lm-section--slide-right"
        // + (!lookActiveFeature && !filtersOpened ? " lm-section--slide-right-more lm-section--hidden" : "")
        + (lookCompatabilityAlert.visible ? " lm-section--active" : " lm-section--hidden")
        + (wizardActiveItem ? " lw-section" : "")}>
        <LookCompatabilitySection wrapperStyles={contentStyles}/>
      </section>
      <section className={"lm-section lm-section--feature lm-section--slide-right"
        + (!lookActiveFeature || showWizard ? " lm-section--slide-right-more lm-section--hidden" : "")
        + (lookLockedTutorial.visible ? " lm-section--hidden" : "")
        + (featureSectionIsHidden ? " lm-section--none" : "")}>
        <div className={"lm-content"
          + (!lookActiveCategory ? " lm-content--no-category" : "")
          + (filtersOpened || lookCompatabilityAlert.visible ? " lm-content--slide-down" : "")}
             style={contentStyles}>
          {/*{lookActiveFeature && LOOK_WALLS.includes(lookActiveFeature.partId) ? (*/}
          {/*  <LookWallsSection/>*/}
          {/*) : (*/}
          {/*  <Fragment>*/}
          {/*    <LookFeature/>*/}
          {/*    <LookFeatureInfo/>*/}
          {/*  </Fragment>*/}
          {/*)}*/}
          <Fragment>
            <LookFeature/>
            <LookFeatureInfo/>
          </Fragment>
        </div>
      </section>
      <section className={"lm-section lm-section--category" + (!showWizard ? " lm-section--slide-right lm-section--hidden" : "")}>
        {showWizard ? (
          <LookWizard>
            <LookWizardLmContent/>
          </LookWizard>
        ) : null}
      </section>
      <LookMainWizardSections contentHeight={sectionStyles.height + 12}/>
      <LookMainWizardSelectedSteps/>
    </Fragment>
  )
};


const mapStateToProps = (store) => {
  const {windowWidth} = store.serverState;
  const {lookExpanded, lookActiveFeature, lookActiveCategory, moreInfoOpened, lookCompatabilityAlert, lookLockedTutorial,
    // lookAllWallsOpened
  } = store.lookState;
  const {lookRemovedCartItems} = store.cartState;
  const {showFilters} = store.filterState;
  const {wizardActiveItem} = store.wizardState;

  return {
    // lookOpened,
    lookExpanded,
    windowWidth,
    // windowHeight,
    lookActiveFeature,
    lookActiveCategory,
    moreInfoOpened,
    lookRemovedCartItems,
    // lookAllWallsOpened,
    filtersOpened: showFilters,
    lookCompatabilityAlert,
    lookLockedTutorial,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookMainSections)
